import type { SocialLoginMethod } from '@application/types';
import type { ModalData } from '@presentation/components/Modal';
import type { MouseEventHandler } from 'react';

export interface UseSocialLoginModalData {
  modal: ModalData;
  method?: SocialLoginMethod;
  onGoogleClick?: MouseEventHandler;
  onFacebookClick?: MouseEventHandler;
  loading?: boolean;
}

export interface UseSocialLoginModalProps extends UseSocialLoginModalData {}
